
import Vue, { PropType } from "vue";
import { Alert } from "@/models";

import AlertLongStayListHeader from "./AlertLongStayListHeader.vue";
import AlertLongStayListItem from "./AlertLongStayListItem.vue";

export default Vue.extend({
  name: "AlertLongStayList",

  props: {
    alerts: Array as PropType<Array<Alert>>,
  },

  components: {
    AlertLongStayListHeader,
    AlertLongStayListItem,
  },
});
